import { api } from "@/api"
import type { TenantAddress } from "@/composables/useTenant"

export const updateMerchantAddress = async (
  newValue: TenantAddress
): Promise<TenantAddress> => {
  const { body } = await api.put<TenantAddress>(
    `/tenants/self/address/`,
    {
      body: newValue,
    }
  )

  return body
}
